import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Col, Row, Card, Container, Breadcrumb, Table, Badge, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { ColorPicker } from 'primereact/colorpicker';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import New_description from '../components/New_description';
import Checklist from '../components/Checklist';
import Activity from '../components/Activity';
import Attachment from '../components/Attachment';
import { ToggleButton } from 'primereact/togglebutton';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import { getSocket } from '../context/socket'; // adjust path as needed
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import config from '../config';
import ArchivePopup from '../components/ArchivePopup';
import CardMemberPage from '../components/CardMemberPage';
import PriorityPopup from "../components/PriorityPopup";
import EstimatedHoursPopup from "../components/EstimatedHoursPopup";
import DeadlinePopup from "../components/DeadlinePopup";
import DeleteCardPopup from "../components/DeleteCardPopup";
import ChecklistPopup from "../components/ChecklistPopup";
import { IoHandRightSharp } from "react-icons/io5";
import { MdNewReleases } from "react-icons/md";
import HoldCardPopup from "../components/HoldCardPopup";
import DuplicateTaskPopup from "../components/DuplicateTaskPopup";
import CardSectionPopup from "../components/CardSectionPopup";
import CardTaskData from "../components/CardTaskData";
import CardSectionMeeting from "../components/CardSectionMeeting";
import CardTagPopup from "../components/CardTagPopup";
import { FaSkullCrossbones } from "react-icons/fa";
import { CgFlagAlt } from "react-icons/cg";

const View_edit_taskdetails = ({ taskId, boardId, onClose }) => {
    const { accessToken, userId, role } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const socket = getSocket();
    const [cardDetails, setCardDetails] = useState(null);
    const [carddescription, setCardDescription] = useState(null);
    const [checked, setChecked] = useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [title, setTitle] = useState(null);
    const inputRef = useRef(null);


    /*-----------PopupPart------------*/
    const [activePopup, setActivePopup] = useState(null);

    const togglePopup = (key) => {
        setActivePopup((prev) => (prev === key ? null : key));
    };


    /*-----------Searchpart------------*/

    const [value, setValue] = useState('');
    const [items, setItems] = useState([]);
    const search = (event) => {
        setItems([...Array(10).keys()].map(item => event.query + '-' + item));
    }

    /*------------------LabelList----------------*/

    const [labels, setLabels] = useState([
        { id: Date.now(), title: '', color: '#000000', checked: false }
    ]);

    const addLabel = () => {
        const newLabel = { id: Date.now(), title: '', color: '#000000', checked: false };
        setLabels([...labels, newLabel]);
    };

    const deleteLabel = (id) => {
        setLabels(labels.filter(label => label.id !== id));
    };

    const updateLabel = (id, key, value) => {
        setLabels(labels.map(label => label.id === id ? { ...label, [key]: value } : label));
    };

    /*--------------------Date & time----------------*/

    const [datetime12h, setDateTime12h] = useState(null);


    /*---------------Attachment----------------*/

    const [selectedType, setSelectedType] = useState('');


    useEffect(() => {
        if (userId && taskId) {
            fetchCardData();
        }
    }, [userId, taskId]);


    const handleCardFetched = ({ card }) => {
        setCardDetails(card); // update state or context
        setCardDescription(card.description);
        setTitle(card.title);
    };
    useEffect(() => {
        socket.on("cardFetched", handleCardFetched);

        return () => {
            socket.off("cardFetched", handleCardFetched);
        };
    }, []);

    useEffect(() => {
        const handleCardUpdateTrigger = ({ card_id }) => {
            if (Number(card_id) === Number(taskId)) {
                fetchCardData();
            }
        };

        socket.on("triggerCardUpdate", handleCardUpdateTrigger);

        return () => {
            socket.off("triggerCardUpdate", handleCardUpdateTrigger);
        };
    }, [taskId]);

    const fetchCardData = () => {
        if (!taskId) return;
        socket.emit("fetchCard", { card_id: taskId });
    };


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };


    const getBadgeClass = (type) => {
        switch (type) {
            case 'Normal':
                return 'bg-info';
            case 'Post':
                return 'bg-help';
            case 'Meeting':
                return 'bg-success';
            default:
                return 'bg-dark'; // fallback
        }
    };


    const getPriorityBadgeClass = (priority) => {
        switch (priority) {
            case 'Low':
                return 'bg-info';
            case 'Medium':
                return 'bg-warning';
            case 'High':
                return 'bg-danger';
            case 'Urgent':
                return 'bg-danger';
            default:
                return 'bg-dark';
        }
    };


    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    const handleDoubleClick = () => {
        setIsEditing(true);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setIsEditing(false);
            if (title.trim() !== '' && title !== cardDetails?.title) {
                socket.emit('editCardTitle', {
                    card_id: taskId,
                    new_title: title,
                    updated_by: userId,
                    board_id: boardId
                });
            }
        } else if (e.key === 'Escape') {
            setTitle(cardDetails?.title); // Reset title
            setIsEditing(false);
        }
    };


    return (
        <>
            <Container fluid>
                <Row className="mx-0">

                    {/*---Right_part--- */}
                    <Col lg={9} md={12} sm={12} className="p-0 right_partD">
                        <Card className="shadow-0 p-0">
                            <Card.Header className="px-0 border-0">
                                {isEditing ? (
                                    <input
                                        ref={inputRef}
                                        type="text"
                                        className="form-control"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        onBlur={() => setIsEditing(false)}
                                    />
                                ) : (
                                    <h5 onDoubleClick={handleDoubleClick} title="Double click to edit">
                                        {cardDetails?.title}
                                    </h5>
                                )}
                                <p className="mb-1">
                                    <small className="text-muted">Brand : </small> <b>{cardDetails?.list?.board?.brand?.brand_name}</b>
                                </p>
                                <p>
                                    <small className="text-muted">Project : </small> <b>{cardDetails?.list?.board?.project?.project_name}</b>
                                </p>
                                <div className="d-flex align-items-center">
                                    <span className="d-flex align-items-center gap-2 mb-2">
                                        <small className="text-muted">
                                            Members
                                        </small>

                                        <AvatarGroup>
                                            {cardDetails?.members?.map((member) => {
                                                const fullName = `${member.first_name} ${member.last_name}`;

                                                return (
                                                    <React.Fragment key={member.id}>
                                                        <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                                        <Avatar
                                                            id={`avatar-${member.user_id}`}
                                                            image={member?.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                            shape="circle"
                                                            title={fullName}
                                                        />
                                                    </React.Fragment>
                                                );
                                            })}
                                        </AvatarGroup>
                                    </span>

                                    <span className="d-flex align-items-center gap-2 border-start ms-3 ps-3">
                                        {cardDetails?.priority === 'Urgent' && (
                                            <span title="Urgent">
                                                <CgFlagAlt
                                                    data-pr-tooltip="Priority Task"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{
                                                        fontSize: "18px",
                                                        color: "#ff63a5",
                                                        marginRight: "auto",
                                                    }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </span>
                                        )}
                                        {cardDetails?.on_hold && (
                                            <span title="On Hold">
                                                <IoHandRightSharp
                                                    data-pr-tooltip="Task Hold"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{
                                                        fontSize: "18px",
                                                        color: "#f97316",
                                                        marginRight: "auto",
                                                    }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </span>
                                        )}
                                        {cardDetails?.missed_deadline && (
                                            <span title="Missed Deadline">
                                                <FaSkullCrossbones
                                                    data-pr-tooltip="Deadline Missed"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{
                                                        fontSize: "18px",
                                                        color: "#ff63a5",
                                                        marginRight: "auto",
                                                    }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </span>
                                        )}
                                    </span>
                                </div>

                                <span className="d-flex align-items-center gap-2 mb-2 mt-3" >
                                    <small className="text-muted">
                                        Current Working Member
                                    </small>

                                    <AvatarGroup>
                                        {cardDetails?.tagged_user?.map((member) => {
                                            const fullName = `${member.first_name} ${member.last_name}`;

                                            return (
                                                <React.Fragment key={member.id}>
                                                    <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                                    <Avatar
                                                        id={`avatar-${member.user_id}`}
                                                        image={member?.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                        shape="circle"
                                                        title={fullName}
                                                    />
                                                </React.Fragment>
                                            );
                                        })}
                                    </AvatarGroup>



                                </span>
                                <span className="d-flex align-items-center gap-4 mt-1 mb-0">
                                    <small className={`text-white rounded ${getDueDateClass(cardDetails?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                        <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                        {" "}{formatDate(cardDetails?.createdAt)} - {formatDate(cardDetails?.due_date)}
                                    </small>


                                    <small className="text-muted">
                                        <b style={{ fontSize: '12px' }}>Task Type:</b>{' '}
                                        <Badge
                                            className={getBadgeClass(cardDetails?.task_type)}
                                            style={{ fontSize: '12px' }}
                                        >
                                            {cardDetails?.task_type}
                                        </Badge>
                                    </small>

                                    <small className="text-muted">
                                        <b style={{ fontSize: '12px' }}>Task Priority:</b>{' '}
                                        <Badge
                                            className={getPriorityBadgeClass(cardDetails?.priority)}
                                            style={{ fontSize: '12px' }}
                                        >
                                            {cardDetails?.priority}
                                        </Badge>
                                    </small>
                                    <small className="text-muted">
                                        <b style={{ fontSize: '12px' }}>Est. hours:</b>{' '}
                                        <Badge bg="secondary" style={{ fontSize: '12px' }}>
                                            {cardDetails?.estimated_hours != null
                                                ? `${cardDetails.estimated_hours}h`
                                                : '—'}
                                        </Badge>
                                    </small>
                                    <small className="text-muted">
                                        <b style={{ fontSize: '12px' }}>In list: </b>
                                        <span
                                            style={{
                                                fontSize: '12px',
                                                backgroundColor: cardDetails?.list?.color_code || '#ccc',
                                                color: '#fff',
                                                padding: '0px 5px',
                                                borderRadius: '4px',
                                                display: 'inline-block'
                                            }}
                                        >
                                            {cardDetails?.list?.name}
                                        </span>
                                    </small>


                                </span>
                            </Card.Header>
                            <Card.Body className="px-0 pt-0">
                                {/* <div className="d-flex justify-content-between align-items-start border-bottom pb-3">
                                    <div>
                                        <label className="d-block text-secondary" style={{ fontSize: '12px' }}>Labels</label>
                                        <div className="lableviList mt-2">
                                            <ul>
                                                <li><p>Thanks for contact us with your issues contact us with your issues</p></li>
                                                <li><p>Contact us with </p></li>
                                                <li><p>Thanks for</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div style={{ width: 'clac(100% - 50px)' }}>
                                        <label className="d-block text-secondary mb-2" style={{ fontSize: '12px' }}>Notifications</label>
                                        <ToggleButton
                                            onIcon="pi pi-bell"
                                            offIcon="pi pi-bell-slash"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.value)}
                                            className={`p-0 px-2 border-0 ${checked ? 'text-green-500' : 'text-red-500'}`}
                                            size="small"
                                        />
                                    </div>
                                </div> */}
                                <div className="activity-Div py-4">
                                    <New_description description={carddescription} cardId={taskId} />
                                </div>
                                <div className="activity-Div py-4">
                                    <Checklist cardId={taskId} boardId={boardId} />
                                </div>
                                <div className="activity-Div py-4">
                                    <CardTaskData cardId={taskId} />
                                </div>

                                <div className="activity-Div py-4">
                                    <Activity cardId={taskId} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/*---left_part--- */}

                    <Col lg={3} md={12} sm={12} className="ps-4">
                        <div className="modal-wrapper sticky-top" style={{ top: '40px' }}>
                            <ul className="modal_Kedit">
                                <li><Button label="Members" icon="pi pi-users" className="border-0" onClick={() => togglePopup("members")} /></li>
                                <li><Button label="Task Handover" icon="pi pi-user" className="border-0" onClick={() => togglePopup("tag_member")} /></li>
                                <li><Button label="SubTasks" icon="pi pi-check-square" className="border-0" onClick={() => togglePopup("checklist")} /></li>
                                <li><Button label="Dates" icon="pi pi-clock" className="border-0" onClick={() => togglePopup("dates")} /></li>
                                <li><Button label="Attachment" icon="pi pi-paperclip" className="border-0" onClick={() => togglePopup("attachment")} /></li>
                                <li><Button label="Meeting" icon="pi pi-clipboard" className="border-0" onClick={() => togglePopup("meeting")} /></li>
                                <li><Button label="Copy" icon="pi pi-clone" className="border-0" onClick={() => togglePopup("copy")} /></li>
                                {cardDetails?.is_active && (
                                    <li>
                                        <Button
                                            label="Archive"
                                            icon="pi pi-eye-slash"
                                            className="border-0"
                                            onClick={() => togglePopup("archive")}
                                        />
                                    </li>
                                )}

                                <li><Button label="Priority" icon="pi pi-list" className="border-0" onClick={() => togglePopup("priority")} /></li>
                                <li><Button label="Est. Hours" icon="pi pi-stopwatch" className="border-0" onClick={() => togglePopup("estimated_hours")} /></li>
                                <li>
                                    <Button
                                        className="border-0"
                                        style={{ fontWeight: 500 }}
                                        onClick={() => togglePopup("On_Hold")}
                                    >
                                        {cardDetails?.on_hold ? (
                                            <>
                                                <MdNewReleases style={{ marginRight: 6 }} />
                                                Unhold
                                            </>
                                        ) : (
                                            <>
                                                <IoHandRightSharp style={{ marginRight: 6 }} />
                                                On Hold
                                            </>
                                        )}
                                    </Button>
                                </li>

                                <li><Button label="Delete" icon="pi pi-trash" className="border-0" onClick={() => togglePopup("delete")} /></li>
                            </ul>

                            {activePopup === "members" && (
                                <CardMemberPage
                                    onCancel={() => togglePopup("members")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "tag_member" && (
                                <CardTagPopup
                                    onCancel={() => togglePopup("tag_member")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}



                            {activePopup === "labels" && (
                                <div className="popup-box popup-labels">
                                    <div className="popup-header">
                                        Labels
                                        <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("labels")} />
                                    </div>
                                    <div className="popup-body">
                                        <AutoComplete
                                            value={value}
                                            suggestions={items}
                                            completeMethod={search}
                                            onChange={(e) => setValue(e.value)}
                                            forceSelection
                                            placeholder="Search Labels..."
                                            className="ser_EMP"
                                        />
                                        <p className="text-secondary pt-2 mb-2 d-flex justify-content-between align-items-center">
                                            <b><small>Label List</small></b>
                                            <small>
                                                <Button title="Add Label" icon="pi pi-plus" severity="primary" text className="border-0 p-0" style={{ width: '35px' }} onClick={addLabel} />
                                            </small>
                                        </p>
                                        <ul className="list-EmpLIst">
                                            {labels.map((label, index) => (
                                                <li key={label.id} className="d-flex align-items-center gap-2 mb-2">
                                                    <small>
                                                        <Checkbox
                                                            inputId={`checkbox-${label.id}`}
                                                            value="Cheese"
                                                            checked={label.checked}
                                                            onChange={(e) => updateLabel(label.id, 'checked', e.checked)}
                                                        />
                                                    </small>
                                                    <small>
                                                        <InputText
                                                            placeholder="Titlename"
                                                            value={label.title}
                                                            onChange={(e) => updateLabel(label.id, 'title', e.target.value)}
                                                        />
                                                    </small>
                                                    <small>
                                                        <ColorPicker
                                                            value={label.color}
                                                            onChange={(e) => updateLabel(label.id, 'color', e.value)}
                                                            style={{ width: '30px' }}
                                                        />
                                                    </small>
                                                    <small>
                                                        <Button
                                                            title="Edit"
                                                            icon="pi pi-pencil"
                                                            severity="secondary"
                                                            text
                                                            className="border-0 p-0"
                                                            style={{ width: '20px' }}
                                                        />
                                                    </small>
                                                    {labels.length > 1 && (
                                                        <small>
                                                            <Button
                                                                title="Delete"
                                                                icon="pi pi-trash"
                                                                severity="danger"
                                                                text
                                                                className="border-0 p-0"
                                                                style={{ width: '20px' }}
                                                                onClick={() => deleteLabel(label.id)}
                                                            />
                                                        </small>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                        <Button label="Create" severity="primary" className="border-0 py-1 px-3 mt-3" />
                                    </div>
                                </div>
                            )}
                            {activePopup === "checklist" && (
                                <ChecklistPopup
                                    onCancel={() => togglePopup("checklist")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "dates" && (
                                <DeadlinePopup
                                    onCancel={() => togglePopup("dates")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "attachment" && (
                                <CardSectionPopup
                                    onCancel={() => togglePopup("attachment")}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}

                            {activePopup === "meeting" && (
                                <CardSectionMeeting
                                    onCancel={() => togglePopup("meeting")}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}

                            {activePopup === "copy" && (
                                <DuplicateTaskPopup
                                    onCancel={() => togglePopup("copy")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "archive" && (
                                <ArchivePopup
                                    onCancel={() => togglePopup("archive")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}


                            {activePopup === "priority" && (
                                <PriorityPopup
                                    onCancel={() => togglePopup("priority")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "estimated_hours" && (
                                <EstimatedHoursPopup
                                    onCancel={() => togglePopup("estimated_hours")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                            {activePopup === "On_Hold" && (
                                <HoldCardPopup
                                    onCancel={() => togglePopup("On_Hold")}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}



                            {activePopup === "delete" && (
                                <DeleteCardPopup
                                    onCancel={() => togglePopup("delete")}
                                    onClose={onClose}
                                    cardDetails={cardDetails}
                                    togglePopup={togglePopup}
                                    cardId={taskId}
                                    boardId={boardId}
                                />
                            )}
                        </div>
                    </Col>
                </Row>




            </Container>
        </>
    );
};

export default View_edit_taskdetails;